import { Fragment } from 'react';
import ChooseUsernameForm from '../chooseUsernameForm';
import i18n from 'src/utils/translate';

export default function Username({setUsername}) {
  return (
    <Fragment>
      <p>{i18n.t('Choose an')}{' '}<strong>{i18n.t('anonymous')}</strong>{' '}{i18n.t('username to safely share your experiences.')}</p>
      <p>{i18n.t('You can change this later.')}</p>
      <ChooseUsernameForm setUsername={setUsername} />
      <div className="signup-box__tips">
        {i18n.t('Tips for an anonymous username:')}
        <ul>
          <li>{i18n.t("Don't use parts of your name, address or phone number")}</li>
          <li>{i18n.t("Don't use the same username you have elsewhere")}</li>
          <li>{i18n.t('Consider your favorite hobby, animal, music, movie, color, etc')}</li>
        </ul>
      </div>
    </Fragment>
  );
}
